import React, { Component } from "react";
import { translate } from "react-i18next";
import moment from "moment";
import renderHTML from "react-render-html";
import img_time from "../../assets/media/redesign/group-5.png";
import Logo from "../../assets/media/moneytable@3x.png";
import { gaEvent } from "../../ga/analytics";
import {
	CATEGORY_HOMEPAGE,
	ACTION_NEWS_UPDATE,
	ACTION_HR_NEWS,
	ACTION_FINANCIAL_NEWS,
	CATEGORY_NEWS,
} from "../../ga/constant";

import { LoadingSpin } from "../style/blog";

class BlogContentCard extends Component {
	sendToGa = (type, list) => {
		if (type === "News") {
			gaEvent(CATEGORY_NEWS, list);
		}

		if (type === "News Update") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_NEWS_UPDATE, list);
		}

		if (type === "HR News") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_HR_NEWS, list);
		}

		if (type === "Financial News") {
			gaEvent(CATEGORY_HOMEPAGE, ACTION_FINANCIAL_NEWS, list);
		}
	};

	constructor(props) {
		super(props);
		this.state = {
			c: 0,
		};
	}

	render() {
		const { i18n } = this.props;
		const url_lang = i18n.language === "en" ? "/en" : "";
		let c = 0;
		return (
			<div>
				{this.props.loading ? (
					<div>
						<LoadingSpin />
					</div>
				) : null}

				{this.props.data &&
					this.props.data.map((blog, index) => {
						const relateDate = moment(
							blog.date,
							"YYYY-MM-DDTh:mm:ss a'"
						).format("MMMM DD, YYYY");
						const blogImage = blog._embedded["wp:featuredmedia"]
							? blog._embedded["wp:featuredmedia"][0].source_url
							: Logo;
						const blogCategories = blog._embedded["wp:term"];
						const titleBlog = renderHTML(blog.title.rendered);

						c = c + 1;
						if (c === 1) {
							return (
								<div className={`newupdate--item`} key={index}>
									<a
										href={`${url_lang}/blog/view/${blog.slug}`}
										onClick={() => this.sendToGa("News", blog.title.rendered)}
										title={titleBlog}
									>
										<div
											className="newupdate--item--poster"
											style={{
												backgroundImage: `url('${blogImage}')`,
												backgroundSize: "cover",
												backgroundPosition: "50% 50%",
											}}
										></div>
										<h5 className="newupdate--item--title" title="">
											{titleBlog}
										</h5>
									</a>
									<div className="newupdate--item--footer">
										{blogCategories.map((item, index) => {
											const category =
												item[0].taxonomy === "category" ? (
													<a
														href={`${url_lang}/blog/category/${item[0].name.toLowerCase()}`}
														onClick={() => this.sendToGa(this.props.type)}
														key={index}
														title={item[0].name}
													>
														<div className="newupdate--item--footer--badge text-center">
															{item[0].name}
														</div>
													</a>
												) : (
													""
												);
											return category;
										})}

										<div className="newupdate--item--footer--time text-center">
											<img src={img_time} alt="" />
											{relateDate}
										</div>
									</div>
								</div>
							);
						}
						// else if (c<=5) {
						//     return (
						//         <li key={index} className="newupdate--item--li">
						//             <a href={`/blog/view/${blog.slug}`} onClick={() => this.sendToGa(this.props.type, blog.title.rendered) } target="_blank" className="txt--th">
						//                 <i className="fas fa-angle-right mr-1"></i> {renderHTML(blog.title.rendered)}
						//             </a>
						//         </li>
						//     );

						// }
						else {
							return true;
						}
					})}
			</div>
		);
	}
}

export default translate("translations")(BlogContentCard);



// WEBPACK FOOTER //
// ./src/components/common/newupdateBlogTemplate.jsx